/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListDialogCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaListDialogCheckbox({
  children,
  viewPath = "/DesignSystem/TysiaListDialog/TysiaListDialogItems/TysiaListDialogCheckbox"
  
}) {
let listDialogSelectedValueData = fromData.useDataValue({ viewPath,
context: 'list_dialog',
path: 'selected',
})
let itemValueData = fromData.useDataValue({ viewPath,
context: 'item',
})
let listDialogItemKeyValueData = fromData.useDataValue({ viewPath,
context: 'list_dialog',
path: 'item_key',
})
let aggregateData = fromHelpers.includes(listDialogSelectedValueData, itemValueData, listDialogItemKeyValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="list_dialog.selected"
 data="item"
 data="list_dialog.item_key"
 aggregate="helpers.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 height={dtSpaceS}
 width={dtSpaceS}
/>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}